export default "__VITE_ASSET__DonTxxj9__"